import React from 'react';
const bonuses = [{
  title: 'DANCE READY™ Ultimate Class Themes Book',
  description: '50 themed class ideas ready to use so you never run out of creative direction again.'
}, {
  title: 'DANCE READY™ 100 Class Starters & Warm-Up Systems',
  description: 'Ready-to-use warm-ups and class openers for every level, energy and class goal.'
}, {
  title: 'DANCE READY™ Cueing & Correction Handbook',
  description: 'The precise phrases to guide, correct and sound like an expert in every single class.'
}, {
  title: 'DANCE READY™ Content & Promotion Kit',
  description: 'Simple tools to promote your classes and attract more students without spending hours on marketing.'
}, {
  title: 'DANCE READY™ Studio-Friendly Printable Planning Pack',
  description: 'Your complete set of printable worksheets, trackers and planning pages for daily studio use.'
}];
const benefits = [{
  emoji: '⚡',
  title: 'Mental Load Liberation',
  desc: 'Open the system, select the class structure that matches your group, and teach. The planning is already done for you.'
}, {
  emoji: '👑',
  title: 'Authority and Confidence',
  desc: "Walk into the studio with an expert's presence and the right words to guide, correct and inspire your students at every level."
}, {
  emoji: '🎶',
  title: 'True Student Progression',
  desc: 'Pedagogically structured sequences so your students feel real improvement — and keep coming back week after week.'
}, {
  emoji: '😌',
  title: 'Zero Transition Stress',
  desc: 'Master the art of fluid class transitions and energy management for a seamless class experience that will impress every student in the room.'
}];
export function BonusSection() {
  return <>
      <section className="py-6 px-4 sm:px-6 bg-brand-cream" data-id="element-15" data-mp="3c5ig3je6t106">
        <div className="text-center mb-4" data-id="element-16" data-mp="3h5mvt779trpc">
          <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-taupe mb-1 uppercase leading-tight" data-id="element-17" data-mp="3h4bude1asw1e">
            5 LUXURY BONUSES INCLUDED
          </h2>
          <p className="text-sm sm:text-base font-subheading font-bold text-brand-rose mb-1" data-id="element-18" data-mp="1c4tzvj5qsde1">
            Plus, you'll receive 5 luxury bonuses
          </p>
          <p className="text-sm text-brand-taupe font-medium leading-tight" data-id="element-19" data-mp="1q1ze46fm0ikd">
            Exclusive resources that will transform your day-to-day — included
            FREE with your pack.
          </p>
        </div>

        <div className="flex flex-col gap-2 mb-4" data-id="element-20" data-mp="yajkvtjjrxl6">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white border-2 border-brand-gold/40 p-3 rounded text-center shadow-sm" data-id="element-21" data-mp="tbzthdm6ptlf" data-mpi={i}>
              <p className="text-[11px] font-button font-bold text-brand-gold mb-0.5 tracking-wider uppercase" data-id="element-22" data-mp="12dg3hk937tp4">
                🎁 BONUS {i + 1} — FREE
              </p>
              <h3 className="text-sm font-bold text-brand-taupe mb-1 leading-tight" data-id="element-23" data-mp="anl1oo41mbjk">
                {bonus.title}
              </h3>
              <p className="text-xs text-brand-taupe/80 font-medium leading-tight" data-id="element-24" data-mp="imlalwvbu21">
                {bonus.description}
              </p>
            </div>)}
        </div>

        <p className="text-center font-button font-bold text-brand-rose text-sm uppercase tracking-wide bg-brand-rose/10 py-2 rounded" data-id="element-25" data-mp="3mre3f4u8jtv3">
          The 5 bonuses are FREE with your purchase today.
        </p>
      </section>

      <section className="py-6 px-4 sm:px-6 bg-white border-t-4 border-brand-beige" data-id="element-26" data-mp="jb77jki2b0wv">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-center text-brand-taupe mb-1 uppercase leading-tight" data-id="element-27" data-mp="o7xqqgp5ycmi">
          WHAT IS GOING TO CHANGE
        </h2>
        <p className="text-sm sm:text-base font-subheading font-bold text-center text-brand-rose mb-1" data-id="element-28" data-mp="ea9u1l7zyv1p">
          What will change in your professional life
        </p>
        <p className="text-sm text-center text-brand-taupe mb-4 font-bold" data-id="element-29" data-mp="2u4a4nhlqkbrr">
          Real benefits starting from the first week:
        </p>

        <div className="flex flex-col gap-2" data-id="element-30" data-mp="3f8erqt9qcmsm">
          {benefits.map((item, i) => <div key={i} className="bg-brand-cream border-l-4 border-brand-rose p-3 rounded-r shadow-sm flex gap-3 items-start" data-id="element-31" data-mp="3agwt4bv6iyat" data-mpi={i}>
              <div className="text-xl shrink-0 leading-none" data-id="element-32" data-mp="35g0o1uz3d63t">{item.emoji}</div>
              <div data-id="element-33" data-mp="30l3gytldh6tk">
                <h3 className="text-sm font-bold text-brand-taupe mb-0.5 uppercase tracking-tight" data-id="element-34" data-mp="30hfo7wnr4ofw">
                  {item.title}
                </h3>
                <p className="text-brand-taupe/80 text-xs font-medium leading-tight" data-id="element-35" data-mp="3t994fo3t99x3">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </section>
    </>;
}